import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { siteInfo } from '../data/mock';
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  const { language, t } = useLanguage();

  const quickLinks = [
    { href: '#home', label: t.nav.home },
    { href: '#tours', label: t.nav.tours },
    { href: '#transfers', label: t.nav.transfers },
    { href: '#areas', label: t.nav.areas },
    { href: '#gallery', label: t.nav.gallery },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-stone-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-full bg-teal-600 flex items-center justify-center font-bold text-lg">
                BA
              </div>
              <div>
                <h3 className="text-xl font-bold">Bali Auto Tour</h3>
                <p className="text-stone-500 text-xs">Tours & Transfers</p>
              </div>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed mb-6">
              {t.footer.description}
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-stone-800 flex items-center justify-center text-stone-400 hover:bg-teal-600 hover:text-white transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-stone-800 flex items-center justify-center text-stone-400 hover:bg-teal-600 hover:text-white transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-stone-800 flex items-center justify-center text-stone-400 hover:bg-teal-600 hover:text-white transition-colors"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-5">{t.footer.quickLinks}</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-stone-400 hover:text-teal-400 transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-5">{t.footer.services}</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-stone-400 text-sm">{t.services.tours.title}</span>
              </li>
              <li>
                <span className="text-stone-400 text-sm">{t.services.transfers.title}</span>
              </li>
              <li>
                <span className="text-stone-400 text-sm">{t.services.roundtrip.title}</span>
              </li>
              <li>
                <span className="text-stone-400 text-sm">{t.services.private.title}</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-5">{t.footer.contact}</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="flex items-center gap-3 text-stone-400 hover:text-teal-400 transition-colors text-sm"
                >
                  <Mail className="w-5 h-5 text-teal-500" />
                  {siteInfo.email}
                </a>
              </li>
              <li>
                <a
                  href={siteInfo.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-stone-400 hover:text-teal-400 transition-colors text-sm"
                >
                  <Phone className="w-5 h-5 text-teal-500" />
                  {siteInfo.whatsapp}
                </a>
              </li>
              <li>
                <a
                  href={siteInfo.googleMapsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-stone-400 hover:text-teal-400 transition-colors text-sm"
                >
                  <MapPin className="w-5 h-5 text-teal-500 flex-shrink-0 mt-0.5" />
                  <span>{siteInfo.address}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-sm">
            &copy; {new Date().getFullYear()} {siteInfo.name}. {t.footer.rights}
          </p>
          <p className="text-stone-600 text-xs">
            {siteInfo.domain}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;